function getSvgUrlId(id) {
  return `url(#${id})`;
}

export { getSvgUrlId };
//# sourceMappingURL=svg.mjs.map
